import { useEffect } from "react";
import Loader from "../Loader/Loader";
import { getterms } from "../service/Mainservice";
import { useState } from "react";
import renderHTML from "react-render-html";
import { useNavigate } from "react-router-dom";

const Termdata = () => {
  const [loading, setloading] = useState(true);
  const [view, setview] = useState(true);

  const navigate = useNavigate();
  useEffect(() => {
    getdata();
  }, []);

  const getdata = async () => {
    try {
      const response = await getterms();
      const data = renderHTML(response.data.data);
      setview(data);
      setloading(false);
    } catch (error) {
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }

      console.log(error);
    }
  };
  return (
    <>
      <div className="Viewdata">
        {view}
        {loading && <Loader />}
      </div>
    </>
  );
};
export default Termdata;
